import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import AppBar from 'material-ui/AppBar';
import Tabs from 'material-ui-next/Tabs';

import CustomTab from './CustomTab';
import SharedDropDownMenu from '../SharedDropDownMenu';
import UpdatePasswordForm from '../UpdatePasswordDialog';
import TopRightMenu from './TopRightMenu';
import Auth from '../../util/auth';


class ApplicationBar extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dataset: PropTypes.string.isRequired,
    onDatasetChange: PropTypes.func.isRequired,
  }

  static contextTypes = {
    datasets: PropTypes.object.isRequired,
    acl: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      activeTab: props.location.pathname,
      showPasswordForm: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.activeTab !== nextProps.location.pathname) {
      this.setState({ activeTab: nextProps.location.pathname});
    }
  }

  handleTabChange = (event, value) => {
    this.setState({
      activeTab: value,
    });
    this.props.history.push(value);
  };

  handleDataSetChange = (event, index, value) => {
    this.props.onDatasetChange(value);
    // Update the query parameter
    this.props.history.push({ search: `?dataset=${value}`});
  }

  handleUpdatePasswordClicked = () => {
    this.setState({ showPasswordForm: true });
  }

  handleRequestClosePasswordForm = () => {
    this.setState({ showPasswordForm: false });
  }

  render() {
    const { showPasswordForm, activeTab } = this.state;
    const {amp:showAmp, dashboard:showDashboard, poi:showPoi} = this.context.acl;
    const showUserMan = Auth.isAdmin();
    const oneDataSetOnly = Object.keys(this.context.datasets).length === 1;

    const styles = {
      tabBar: {
        flex: '2 0 0',
        height: 48,
      },
      appBar: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      menuButtonDiv: {
        width: '48px', marginLeft: 'auto', textAlign: 'right',
        borderRight: '1px solid rgba(0,0,0,0.09)',
      },
      dropDownFlexBox: {
        flex: '0 0 0',
        marginLeft: 'auto',
        textAlign: 'right',
        borderLeft: '1px solid rgba(0,0,0,0.09)',
        borderRight: '1px solid rgba(0,0,0,0.09)',
      },
      dropDownLabelStyle: {
        height: '48px',
        lineHeight: '48px',
        fontSize: '14px',
        // needed to override the disabled color and pointer:
        color: 'rgba(0,0,0,.74)',
        cursor: oneDataSetOnly ? 'auto' : 'pointer'
      },
      dropDownIconStyle: {
        fill: 'rgba(0,0,0,.54)',
        visibility: oneDataSetOnly ? 'hidden' : 'visible',
      },
      logoContainer: {
        width: '120px',
      },
      logo: {
        margin: '7px 0px 3px',
      },
    }

    return (
      <AppBar 
        style={styles.appBar}
        showMenuIconButton={false}
        title={
          <div className="AppBarWrapper">
            <div style={styles.logoContainer}>
              <img src={process.env.REACT_APP_BASE_PATH + '/logo_screen6_210x64.png'} alt="logo" height="32" style={styles.logo} />
            </div>

            <Tabs
              value={activeTab}
              onChange={this.handleTabChange}
              style={styles.tabBar}
              fullWidth={false}
              scrollable={false}
              scrollButtons={"off"}
            >
              <CustomTab label="Home" value="/home" />
              {showDashboard && <CustomTab label="Reporting" value="/dash" />}
              {showAmp && <CustomTab label="Amplification" value="/amp/run" />}
              {showPoi && <CustomTab label="POI" value="/poi/run" />}
              {showUserMan && <CustomTab label="User Management" value="/admin/users" />}
            </Tabs>

            <div style={styles.dropDownFlexBox}>
              <SharedDropDownMenu
                value={this.props.dataset}
                labelStyle={styles.dropDownLabelStyle}
                iconStyle={styles.dropDownIconStyle}
                onChange={this.handleDataSetChange}
                disabled={oneDataSetOnly}
                datasets={this.context.datasets}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              />
            </div>

            <div style={styles.menuButtonDiv}>
              <TopRightMenu onUpdatePasswordClicked={this.handleUpdatePasswordClicked} />
            </div>
            {showPasswordForm && <UpdatePasswordForm onRequestClose={this.handleRequestClosePasswordForm}/>}
          </div>
        }
      />
    )
  }
}

export default withRouter(ApplicationBar);



// WEBPACK FOOTER //
// ./src/components/ApplicationBar/index.jsx